export function AttemptConnectionBanner({ offline }: { offline: boolean }) {
  if (!offline) return null;
  return (
    <div className="lms-attempt-connection" role="status" aria-live="polite">
      Sin conexión. Tus respuestas se guardan en este dispositivo y se enviarán al recuperar la conexión.
    </div>
  );
}
